import axios from "axios";
import { useState } from "react";
import Cookies from "js-cookie";

const useSendEmail = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);

  const sendEmail = async (subject, messageBody, email) => {
    const formData = new FormData();

    // Append necessary data
    formData.append("message_body", messageBody);
    formData.append("email", email);
    formData.append("subject", subject);

    const accessToken = Cookies.get("access_token");

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/send_email/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${accessToken}`,
            "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
          },
        }
      );

      setResponse(result.data);
      setError(null);
    } catch (err) {
      setError(err.response ? err.response.data : err.message);
      setResponse(null);
    }
  };

  return { sendEmail, response, error };
};

export default useSendEmail;
